import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a wall clock mounted at 1.8 m against the z=0 wall plane,
// facing +Z: a warm-white face in a thin matte-black rim, two hands set to
// ten past ten and a brass centre dot.
const BLACK = "#2e2e30";
const WHITE = "#efece6";
const BRASS = "#c9a35a";

const MOUNT_Y = 1.8;
const FACE_Z = 0.035;

/** A clock hand: a thin box radiating from the face centre at `ang`
 *  (radians clockwise from 12 o'clock). */
function hand(len: number, ang: number): Part {
  return {
    geometry: new THREE.BoxGeometry(0.016, len, 0.01), color: BLACK,
    position: [Math.sin(ang) * (len / 2), MOUNT_Y + Math.cos(ang) * (len / 2), FACE_Z + 0.02],
    rotation: [0, 0, -ang],
  };
}

export const wallClock = defineModel({
  id: "wall-clock",
  batchId: "modern",
  name: "Wall clock",
  tags: ["modern", "interior", "fixture", "decor", "wall", "clock"],
  summary: "A minimal wall clock with a white face and black rim.",
  description:
    "Wall-mounted at 1.8 m against the z=0 plane, facing +Z. Place against " +
    "any wall piece of the Modern Living kit.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Thin rim behind the face.
      { geometry: new THREE.CylinderGeometry(0.18, 0.18, 0.03, 20), color: BLACK,
        position: [0, MOUNT_Y, 0.015], rotation: [Math.PI / 2, 0, 0] },
      // Warm-white face.
      { geometry: new THREE.CylinderGeometry(0.165, 0.165, 0.02, 20), color: WHITE,
        position: [0, MOUNT_Y, FACE_Z], rotation: [Math.PI / 2, 0, 0] },
      // Hour hand (ten o'clock) and minute hand (two minutes past).
      hand(0.09, (-2 * Math.PI) / 6),
      hand(0.13, Math.PI / 15),
      // Brass centre dot.
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 0.015, 10), color: BRASS,
        position: [0, MOUNT_Y, FACE_Z + 0.028], rotation: [Math.PI / 2, 0, 0] },
    ];
  },
  animations: [],
});
